"use server";

import { gql } from "./client";

/** `logEvent` returns Boolean! with no selection set (D34). */
type LogEventData = { logEvent: boolean };
import { M_LOG_EVENT } from "./operations";

/**
 * First-party engagement telemetry (B17) — `page_view`, `search`, … The backend
 * `logEvent` is **auth-only** and captures `ip`/`userAgent` server-side; auth is
 * attached here via the httpOnly cookie. Callers should only fire for signed-in
 * users (a guest call is rejected with `Unauthorized`).
 *
 * Fire-and-forget: failures are swallowed — losing one event must never affect
 * the UI. `metadata` is sent as a JSON-encoded string (the backend stores JSONB).
 * Keep it minimal (no extra PII beyond what the event needs, e.g. a path/query).
 */
export async function logEvent(event: string, metadata?: Record<string, unknown>): Promise<void> {
  try {
    await gql<LogEventData>(
      M_LOG_EVENT,
      { event, metadata: metadata ? JSON.stringify(metadata) : null },
      { cache: "no-store" },
    );
  } catch {
    /* best-effort telemetry — swallow */
  }
}
